// extracted by mini-css-extract-plugin
export default {"popover":"xajxaej8IpRlvvk4ohYn"};